'use client'

import { useEffect, useState } from 'react'

import { usePathname } from 'next/navigation'

import cn from 'clsx'
import { SocialIcon } from 'react-social-icons'

import { NavLink } from 'shared-components'
import { getShareSites } from 'shared-functions'

import Copy from '../../images/copy'
import Tick from '../../images/tick'

import s from './Share.module.sass'

function Share() {
    const [currentUrl, setCurrentUrl] = useState<any>(null)
    const [copied, setCopied] = useState<any>(false)

    const pathname = usePathname()

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                const encodedUrl = encodeURIComponent(window.location.href)
                setCurrentUrl({
                    url: window.location.href,
                    encodedUrl,
                })
            }, 100)
        }
    }, [pathname])

    if (!currentUrl) {
        return null
    }

    const handleCopyUrl = async () => {
        try {
            await navigator.clipboard.writeText(currentUrl?.url)
            setCopied(true)

            setTimeout(() => {
                setCopied(false)
            }, 2000)
        } catch (err) {
            console.error('Failed to copy: ', err)
        }
    }

    const shareSites = getShareSites(currentUrl?.encodedUrl)

    const radius = 40
    const fgColor = 'var(--colour-royal-blue)'

    return (
        <div className={s.Share}>
            <div>
                <span className="smallCaps">Share this</span>
                <ul>
                    <li>
                        <button
                            onClick={handleCopyUrl}
                            style={{
                                height: radius,
                                width: radius,
                                backgroundColor: '#FFFFFF',
                                borderColor: 'var(--colour-royal-blue)',
                            }}
                            className={copied ? s.ButtonCopied : ''}
                        >
                            {!copied ? Copy : Tick}
                        </button>
                        <span className={cn(s.Copied, copied && s.Visible)}>Copied!</span>
                    </li>
                    {shareSites?.map((site, index) => {
                        const { company, href } = site

                        return (
                            <li key={index}>
                                <NavLink href={href}>
                                    <SocialIcon
                                        network={company === 'twitter' ? 'x' : undefined}
                                        url={href}
                                        as="div"
                                        bgColor="#FFFFFF"
                                        fgColor={fgColor}
                                        borderRadius="0"
                                        style={{
                                            height: radius,
                                            width: radius,
                                        }}
                                    />
                                </NavLink>
                            </li>
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default Share
